(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bra-fit-calculator"] && !Shopify.designMode) return;
  try {
    
(function(){
 function __mbfcInit(){

/* ---------------- Montelle size chart logic (revised 2026) ---------------- */
const CUPS = ['A','B','C','D','E','F','G','H','I'];

// Full chart data — band row + underbust ranges + cup measurements per unit.
// Cup values: inches are single numbers; cm are ranges. null = not offered (cup H on small bands).
const CHART_ROWS = [
  {band:28, ubIn:'25 – 26.75', ubCm:'63.5 – 68',
    in:['28.5 – 29','29.5 – 30','30.5 – 31','31.5 – 32','32.5 – 33','33.5 – 34','34.5 – 35','35.5 – 36','36.5 – 37'],
    cm:['72.5 – 74','74.5 – 76','76.5 – 79','79.5 – 81.5','82 – 84','84.5 – 86.5','87 – 89','89.5 – 91.5','92 – 94']},
  {band:30, ubIn:'27 – 28.75', ubCm:'68.5 – 73',
    in:['30.5 – 31','31.5 – 32','32.5 – 33','33.5 – 34','34.5 – 35','35.5 – 36','36.5 – 37','37.5 – 38','38.5 – 39'],
    cm:['76.5 – 79','79.5 – 81.5','82 – 84','84.5 – 86.5','87 – 89','89.5 – 91.5','92 – 94','94.5 – 96.5','97 – 99']},
  {band:32, ubIn:'29 – 30.75', ubCm:'73.5 – 78',
    in:['32.5 – 33','33.5 – 34','34.5 – 35','35.5 – 36','36.5 – 37','37.5 – 38','38.5 – 39','39.5 – 40','40.5 – 41'],
    cm:['82 – 84','84.5 – 86.5','87 – 89','89.5 – 91.5','92 – 94','94.5 – 96.5','97 – 99','99.5 – 102','102.5 – 104']},
  {band:34, ubIn:'31 – 32.75', ubCm:'78.5 – 83',
    in:['34.5 – 35','35.5 – 36','36.5 – 37','37.5 – 38','38.5 – 39','39.5 – 40','40.5 – 41','41.5 – 42','42.5 – 43'],
    cm:['87 – 89','89.5 – 91.5','92 – 94','94.5 – 96.5','97 – 99','99.5 – 102','102.5 – 104','104.5 – 107','107.5 – 109.5']},
  {band:36, ubIn:'33 – 34.75', ubCm:'83.5 – 88.5',
    in:['36.5 – 37','37.5 – 38','38.5 – 39','39.5 – 40','40.5 – 41','41.5 – 42','42.5 – 43','43.5 – 44','44.5 – 45'],
    cm:['92 – 94','94.5 – 96.5','97 – 99','99.5 – 102','102.5 – 104','104.5 – 107','107.5 – 109.5','110 – 112','112.5 – 114.5']},
  {band:38, ubIn:'35 – 36.75', ubCm:'89 – 93.5',
    in:['38.5 – 39','39.5 – 40','40.5 – 41','41.5 – 42','42.5 – 43','43.5 – 44','44.5 – 45','45.5 – 46','46.5 – 47'],
    cm:['97 – 99','99.5 – 102','102.5 – 104','104.5 – 107','107.5 – 109.5','110 – 112','112.5 – 114.5','115 – 117','117.5 – 119.5']},
  {band:40, ubIn:'37 – 38.75', ubCm:'94 – 98.5',
    in:['40.5 – 41','41.5 – 42','42.5 – 43','43.5 – 44','44.5 – 45','45.5 – 46','46.5 – 47','47.5 – 48','48.5 – 49'],
    cm:['102.5 – 104','104.5 – 107','107.5 – 109.5','110 – 112','112.5 – 114.5','115 – 117','117.5 – 119.5','120 – 122','122.5 – 124.5']},
  {band:42, ubIn:'39 – 40.75', ubCm:'99 – 103.5',
    in:['42.5 – 43','43.5 – 44','44.5 – 45','45.5 – 46','46.5 – 47','47.5 – 48','48.5 – 49','49.5 – 50','50.5 – 51'],
    cm:['107.5 – 109.5','110 – 112','112.5 – 114.5','115 – 117','117.5 – 119.5','120 – 122','122.5 – 124.5','125 – 127','127.5 – 129.5']},
  {band:44, ubIn:'41 – 43',    ubCm:'104 – 109.5',
    in:['44.5 – 45','45.5 – 46','46.5 – 47','47.5 – 48','48.5 – 49','49.5 – 50','50.5 – 51','51.5 – 52','52.5 – 53'],
    cm:['112.5 – 114.5','115 – 117','117.5 – 119.5','120 – 122','122.5 – 124.5','125 – 127','127.5 – 129.5','130 – 132','132.5 – 134.5']}
];

// parse a range string like '28.5 – 29' into [lo, hi]
function parseRange(str){
  const parts = str.split('–').map(s=>parseFloat(s.trim()));
  return [parts[0], parts[1]];
}

// find the CHART_ROWS row whose underbust range contains u
function getRow(uNative, u){
  const key = u === 'cm' ? 'ubCm' : 'ubIn';
  for (let i = 0; i < CHART_ROWS.length; i++){
    const [lo, hi] = parseRange(CHART_ROWS[i][key]);
    if (uNative >= lo && uNative <= hi) return CHART_ROWS[i];
  }
  // fell between ranges — find closest row by midpoint
  let closest = null, minDist = Infinity;
  for (let i = 0; i < CHART_ROWS.length; i++){
    const [lo, hi] = parseRange(CHART_ROWS[i][key]);
    const mid = (lo + hi) / 2;
    const dist = Math.abs(uNative - mid);
    if (dist < minDist){ minDist = dist; closest = CHART_ROWS[i]; }
  }
  return closest;
}

// find which cup index the overbust falls into for a given row
function getCupIdx(oNative, row, u){
  const ranges = u === 'cm' ? row.cm : row.in;
  for (let i = 0; i < ranges.length; i++){
    const [lo, hi] = parseRange(ranges[i]);
    if (oNative >= lo && oNative <= hi) return i;
  }
  // value not inside any range: find closest by midpoint
  let closest = 0, minDist = Infinity;
  for (let i = 0; i < ranges.length; i++){
    const [lo, hi] = parseRange(ranges[i]);
    const mid = (lo + hi) / 2;
    const dist = Math.abs(oNative - mid);
    if (dist < minDist){ minDist = dist; closest = i; }
  }
  return closest;
}

// sizes not carried by Montelle
const NOT_CARRIED = new Set(['28A','28B','28I','30A','30I','32I','34I','36I','38I','40A','42A','42H','42I','44A','44D','44E','44F','44G','44H','44I']);

function computeSize(uNative, oNative, u){
  if (oNative <= uNative) return {error:'swap'};
  const row = getRow(uNative, u);
  if (!row) return {error:'range'};
  // hard out-of-range check: overbust must be within the band row's min/max
  const ranges = u === 'cm' ? row.cm : row.in;
  const [firstLo] = parseRange(ranges[0]);
  const [, lastHi] = parseRange(ranges[ranges.length - 1]);
  if (oNative < firstLo || oNative > lastHi) return {error:'range'};
  const idx = getCupIdx(oNative, row, u);
  if (idx === null) return {error:'range'};
  const size = row.band + CUPS[idx];
  if (NOT_CARRIED.has(size)) return {error:'range'};
  return {size, band: row.band, cup: CUPS[idx]};
}

/* ---------------- unit + dropdown handling ---------------- */
let unit = 'in';
const FRACTIONS_IN = ['', '1/8','1/4','3/8','1/2','5/8','3/4','7/8'];
const FRAC_VAL = {'':0,'1/8':.125,'1/4':.25,'3/8':.375,'1/2':.5,'5/8':.625,'3/4':.75,'7/8':.875};

const els = {
  ubWhole:document.getElementById('ubWhole'), ubFrac:document.getElementById('ubFrac'),
  obWhole:document.getElementById('obWhole'), obFrac:document.getElementById('obFrac'),
  ubUnit:document.getElementById('ubUnit'),   obUnit:document.getElementById('obUnit'),
  calcBtn:document.getElementById('calcBtn'),
  result:document.getElementById('result'),   sizeOut:document.getElementById('sizeOut'),
  error:document.getElementById('error'),      emsg:document.getElementById('emsg'),
  shopBtn:document.getElementById('shopBtn')
};

function opt(v,t){const o=document.createElement('option');o.value=v;o.textContent=t;return o;}

function buildDropdowns(){
  [els.ubWhole,els.ubFrac,els.obWhole,els.obFrac].forEach(s=>s.innerHTML='');
  els.ubWhole.appendChild(opt('','Select')); els.ubFrac.appendChild(opt('','Select'));
  els.obWhole.appendChild(opt('','Select')); els.obFrac.appendChild(opt('','Select'));

  if (unit === 'in'){
    els.ubUnit.textContent='inches'; els.obUnit.textContent='inches';
    for(let i=25;i<=43;i++) els.ubWhole.appendChild(opt(i,i+'"'));
    for(let i=26;i<=53;i++) els.obWhole.appendChild(opt(i,i+'"'));
    FRACTIONS_IN.forEach(f=>els.ubFrac.appendChild(opt(f, f===''?'0':f)));
    FRACTIONS_IN.forEach(f=>els.obFrac.appendChild(opt(f, f===''?'0':f)));
  } else {
    els.ubUnit.textContent='cm'; els.obUnit.textContent='cm';
    for(let i=64;i<=109;i++) els.ubWhole.appendChild(opt(i,i+' cm'));
    for(let i=66;i<=134;i++) els.obWhole.appendChild(opt(i,i+' cm'));
    ['','.5'].forEach(f=>els.ubFrac.appendChild(opt(f, f===''?'.0':f)));
    ['','.5'].forEach(f=>els.obFrac.appendChild(opt(f, f===''?'.0':f)));
  }
}

// returns the measurement in the CURRENT display unit (in or cm), or null if not chosen.
// fracSel is optional — when omitted (e.g. overbust), only whole units are used.
function readNative(wholeSel, fracSel){
  if (wholeSel.value === '') return null;
  let whole = parseFloat(wholeSel.value);
  let frac = 0;
  if (fracSel){
    if (unit === 'in'){ frac = FRAC_VAL[fracSel.value] || 0; }
    else { frac = fracSel.value === '.5' ? .5 : 0; }
  }
  return whole + frac;
}

function refreshBtn(){
  els.calcBtn.disabled = !(els.ubWhole.value !== '' && els.obWhole.value !== '');
  save();
}

let chartAPI = null;   // bridge to the interactive chart (set in renderChart)

function shopUrl(band, cup){
  const cupAliases = {
    'B': 'B%2FC', 'C': 'B%2FC',
    'D': 'D%2FE', 'E': 'D%2FE',
    'F': 'F%2FG', 'G': 'F%2FG',
    'H': 'H%2FI'
  };
  var url = '/collections/montelle-bras?filter.v.option.dimension=' + encodeURIComponent(cup);
  if (cupAliases[cup]) url += '&filter.v.option.dimension=' + cupAliases[cup];
  url += '&filter.v.option.size=' + encodeURIComponent(band) + '&sort_by=manual';
  return url;
}

function calculate(){
  const u = readNative(els.ubWhole, els.ubFrac);
  const o = readNative(els.obWhole, els.obFrac);
  hideAll();
  if (u === null || o === null) return;
  const r = computeSize(u, o, unit);
  if (r.error === 'swap'){
    show(els.error); els.emsg.textContent =
      'Your overbust measurement should be larger than your underbust. Please double-check that you haven’t swapped the two and try again.';
    if (chartAPI) chartAPI.clear();
    return;
  }
  if (r.error){
    show(els.error); els.emsg.textContent =
      'Every body is beautiful, and your measurements are perfect for you! Regrettably, they fall outside our current size range, so we don’t have your size in stock. If you’d like some help re-measuring or want to chat about your fit, our experts are always here for you—just drop us a message in the chat!';
    if (chartAPI) chartAPI.clear();
    return;
  }
  els.sizeOut.textContent = r.size;
  els.shopBtn.href = shopUrl(r.band, r.cup);
  show(els.result);
  if (chartAPI) chartAPI.selectBySize(r.size);   // auto-highlight the matching chart cell
  els.result.scrollIntoView({behavior:'smooth',block:'center'});
}

function hideAll(){els.result.classList.remove('show');els.error.classList.remove('show');}
function show(el){el.classList.add('show');}

function clearAnswer(){
  els.ubWhole.value=''; els.ubFrac.value=''; els.obWhole.value=''; els.obFrac.value='';
  hideAll(); refreshBtn(); localStorage.removeItem('montelleFit');
  if (chartAPI) chartAPI.clear();   // keep the chart in sync
}

/* ---------------- persistence ---------------- */
function save(){
  localStorage.setItem('montelleFit', JSON.stringify({
    unit, ub:els.ubWhole.value, ubf:els.ubFrac.value, ob:els.obWhole.value, obf:els.obFrac.value
  }));
}
function restore(){
  try{
    const s = JSON.parse(localStorage.getItem('montelleFit')||'{}');
    if (s.unit){ unit = s.unit; syncToggle(); }
    buildDropdowns();
    if (s.ub!==undefined) els.ubWhole.value=s.ub;
    if (s.ubf!==undefined) els.ubFrac.value=s.ubf;
    if (s.ob!==undefined) els.obWhole.value=s.ob;
    if (s.obf!==undefined) els.obFrac.value=s.obf;
  }catch(e){ buildDropdowns(); }
  refreshBtn();
}

/* ---------------- unit toggle wiring ---------------- */
const toggle = document.getElementById('unitToggle');
const chartToggle = document.getElementById('chartToggle');

function syncToggle(){
  [toggle, chartToggle].forEach(t=>{
    t.querySelectorAll('button').forEach(b=>b.classList.toggle('active', b.dataset.unit===unit));
  });
}

function handleUnitChange(newUnit){
  if (newUnit === unit) return;
  unit = newUnit; syncToggle(); buildDropdowns(); hideAll(); refreshBtn();
  if (chartAPI) chartAPI.setUnit();
}

toggle.addEventListener('click', e=>{
  const b = e.target.closest('button'); if(!b) return;
  handleUnitChange(b.dataset.unit);
});
chartToggle.addEventListener('click', e=>{
  const b = e.target.closest('button'); if(!b) return;
  handleUnitChange(b.dataset.unit);
});

[els.ubWhole,els.ubFrac,els.obWhole].forEach(s=>s.addEventListener('change',refreshBtn));
els.calcBtn.addEventListener('click', calculate);

/* ---------------- interactive size chart (inches + cm) ---------------- */
(function initChart(){
  const tb = document.getElementById('chartBody');
  const cupHeaders = [...document.querySelectorAll('.chart thead .cuph')];
  const lead = document.getElementById('chartLead');
  const pickText = document.getElementById('chartPickText');
  const clearBtn = document.getElementById('chartClear');
  const shopLink = document.getElementById('chartShop');
  let selectedTd = null;
  let selKey = null;            // {band, cup} — unit-independent so selection survives a unit switch

  function clearHover(){
    document.querySelectorAll('.chart th.hl').forEach(e=>e.classList.remove('hl'));
  }
  function applySelection(td){
    if (selectedTd){ selectedTd.classList.remove('sel'); selectedTd.removeAttribute('aria-pressed'); }
    document.querySelectorAll('.chart th.selhdr').forEach(e=>e.classList.remove('selhdr'));
    selectedTd = td;
    if (!td){
      selKey = null;
      pickText.textContent = 'Hover to explore, then tap a measurement to select your size.';
      clearBtn.hidden = true; shopLink.hidden = true; shopLink.removeAttribute('href');
      return;
    }
    selKey = {band: td.dataset.band, cup: td.dataset.cup};
    td.classList.add('sel'); td.setAttribute('aria-pressed','true');
    const rowTh = td.parentElement.querySelector('th'); if (rowTh) rowTh.classList.add('selhdr');
    const colTh = cupHeaders[+td.dataset.cup]; if (colTh) colTh.classList.add('selhdr');
    const m = unit === 'cm' ? ' cm' : '"';
    pickText.innerHTML = 'Your selected size: <strong>'+td.dataset.size+'</strong>'
      + ' &middot; '+td.dataset.over+m+' overbust, '+td.dataset.ub+m+' underbust';
    shopLink.href = shopUrl(td.dataset.band, CUPS[+td.dataset.cup]);
    shopLink.textContent = 'Shop ' + td.dataset.size;
    shopLink.hidden = false;
    clearBtn.hidden = false;
  }
  function saveChartPick(){
    if (selKey) localStorage.setItem('montelleChartPick', JSON.stringify(selKey));
    else localStorage.removeItem('montelleChartPick');
  }

  function render(){
    tb.innerHTML = '';
    const isCm = unit === 'cm';
    const m = isCm ? ' cm' : '"';
    if (lead) lead.textContent = 'All measurements in ' + (isCm ? 'centimeters' : 'inches')
      + '. Find your band size on the left, then read across to the cup column that matches your overbust measurement.';

    CHART_ROWS.forEach(row=>{
      const tr = document.createElement('tr');
      const ub = isCm ? row.ubCm : row.ubIn;
      const th = document.createElement('th');
      th.dataset.band = row.band;
      th.innerHTML = row.band + '<br><small class="ub-range">'+ub+m+'</small>';
      tr.appendChild(th);

      const cells = isCm ? row.cm : row.in;
      for(let i=0;i<9;i++){
        const td = document.createElement('td');
        const val = cells[i];
        const sizeName = row.band + CUPS[i];
        if (val == null || NOT_CARRIED.has(sizeName)){ td.className = 'empty'; td.textContent = '—'; tr.appendChild(td); continue; }
        td.textContent = val + m;
        td.dataset.band = row.band; td.dataset.cup = i;
        td.dataset.over = val; td.dataset.ub = ub;
        td.dataset.size = sizeName;
        td.tabIndex = 0; td.setAttribute('role','button');
        td.setAttribute('aria-label', 'Select size ' + row.band + CUPS[i]);
        td.title = 'Size ' + row.band + CUPS[i];
        td.addEventListener('mouseenter', ()=>{
          clearHover(); th.classList.add('hl');
          if (cupHeaders[i]) cupHeaders[i].classList.add('hl');
        });
        td.addEventListener('mouseleave', clearHover);
        td.addEventListener('click', ()=>{
          applySelection(selectedTd === td ? null : td);   // click again to deselect
          saveChartPick();
        });
        td.addEventListener('keydown', e=>{
          if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); td.click(); }
        });
        tr.appendChild(td);
      }
      tb.appendChild(tr);
    });

    // re-apply any existing selection to the freshly built cells
    selectedTd = null;
    if (selKey){
      const td = tb.querySelector('td[data-band="'+selKey.band+'"][data-cup="'+selKey.cup+'"]');
      if (td) applySelection(td); else applySelection(null);
    }
  }

  render();

  clearBtn.addEventListener('click', ()=>{ applySelection(null); saveChartPick(); });

  // restore saved selection
  try{
    const s = JSON.parse(localStorage.getItem('montelleChartPick') || 'null');
    if (s){
      selKey = s;
      const td = tb.querySelector('td[data-band="'+s.band+'"][data-cup="'+s.cup+'"]');
      if (td) applySelection(td);
    }
  }catch(e){}

  // bridge for the calculator + unit toggle
  chartAPI = {
    selectBySize(size){
      const td = tb.querySelector('td[data-size="'+size+'"]');
      if (td){ applySelection(td); saveChartPick(); }
    },
    clear(){ applySelection(null); saveChartPick(); },
    setUnit(){ render(); }
  };
})();

window.clearAnswer = clearAnswer;
restore();

 }
 if (document.readyState !== 'loading') { __mbfcInit(); }
 else { document.addEventListener('DOMContentLoaded', __mbfcInit); }
})();

  } catch(e) { console.error(e); }
})();
})();
